/**
 * Telegram Mini Apps Analytics SDK integration
 */

// Define types for the Telegram Analytics SDK
interface TelegramAnalyticsOptions {
  token: string;
  appName: string;
}

interface TelegramAnalytics {
  init(options: TelegramAnalyticsOptions): void;
}

// Declare the global window object with our extensions
declare global {
  interface Window {
    telegramAnalytics?: TelegramAnalytics;
  }
}

/**
 * Initialize the Telegram Analytics SDK
 */
export function initAnalytics(): void {
  if (!window.telegramAnalytics) {
    console.warn('Telegram Analytics SDK not loaded');
    return;
  }

  const token = import.meta.env.VITE_TELEGRAM_ANALYTICS_TOKEN;
  const appName = import.meta.env.VITE_TELEGRAM_APP_NAME;

  if (!token) {
    console.warn('Telegram Analytics token not found in environment variables');
    return;
  }

  try {
    window.telegramAnalytics.init({
      token: token as string,
      appName: (appName as string) || 'jwallet_tma',
    });
    console.log('Telegram Analytics initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Telegram Analytics:', error);
  }
}